<div class="modal-dialog modal-lg">
	<div class="modal-content">
		<div class="modal-body">
			{{{content}}}
		</div>
	</div>
</div>